$(document).ready(function() {

  // ---------------------------------------------------------------------------
  // Creative Rewards deep link: /#creativerewards opens Smile panel
  // ---------------------------------------------------------------------------
  if (window.location.hash) {
    let hash = window.location.hash.substring(1);
    hash = hash.toLowerCase();
    if ('creativerewards' === hash) {
      if (window.SmileUI) {
        SmileUI.ready()
          .then(function(smileUiInstance) {
            SmileUI.openPanel();
          })
          .catch(function(err) {
            console.log(err);
          });
      } else {
        document.addEventListener('smile-ui-loaded', function() {
          SmileUI.ready()
            .then(function(smileUiInstance) {
              SmileUI.openPanel();
            })
            .catch(function(err) {
              console.log(err);
            });
        });
      }
    }
  }

  // ---------------------------------------------------------------------------
  // Promo toggle boxes (accordion-style open/close)
  // ---------------------------------------------------------------------------
  $(document).on('click', '.toggle-box', function(e) {
    e.preventDefault();
    $(this).parent().find('.promo').toggleClass('active');
    $(this).parent().find('label').toggleClass('open');

    var x = window.pageXOffset;
    var y = window.pageYOffset;
    $(window).one('scroll', function() {
      window.scrollTo(x, y);
    });
  });

  // ---------------------------------------------------------------------------
  // Max quantity validation on inputs with .has-max-qty
  // ---------------------------------------------------------------------------
  $(document).on('focusout', '.has-max-qty', function() {
    $('.max-qty-error').remove();
    var currentQty = parseInt($(this).val(), 10);
    var allowQty = parseInt($(this).attr('max'), 10);

    if (currentQty > allowQty) {
      $(this).val(allowQty);
      $(this)
        .parent()
        .next()
        .append(
          '<div class="max-qty-error"> Only maximum ' +
            allowQty +
            ' quantity allowed per order</div>'
        );
    }
  });

  // ---------------------------------------------------------------------------
  // Shared "In Cart" label + pressed state
  // ---------------------------------------------------------------------------
  var ATC_IN_CART_LABEL = 'In Cart';

  /**
   * Sync main product page buttons (.js-atc-button) with the cart
   * Uses data-product-id="{{ product.id }}"
   */
  function syncMainProductButtons(cart) {
    var $buttons = $('.js-atc-button');
    if (!$buttons.length) return;

    $buttons.each(function() {
      var $btn = $(this);

      // Store original label once
      if (!$btn.data('original-label')) {
        $btn.data(
          'original-label',
          $btn.val()
        );
      }

      var productId = String($btn.data('product-id') || '');

      var inCart = cart.items.some(function(item) {
        return String(item.product_id) === productId;
      });

      if (inCart) {
        $btn.val(ATC_IN_CART_LABEL);
        $btn.addClass('is-in-cart');
      } else {
        $btn.val($btn.data('original-label'));
        $btn.removeClass('is-in-cart');
      }
    });
  }

  /**
   * Sync collection/grid buttons (.list__add-to-cart) with the cart
   * Uses data-product-id / data-variant-id
   */
  function syncCollectionButtons(cart) {
    var $buttons = $('.list__add-to-cart');
    if (!$buttons.length) return;

    $buttons.each(function() {
      var $btn = $(this);

      // Store original label once
      if (!$btn.data('original-label')) {
        $btn.data(
          'original-label',
          $btn.val()
        );
      }

      var productId = String($btn.data('product-id') || '');
      var variantId = String($btn.data('variant-id') || '');

      var inCart = cart.items.some(function(item) {
        return (
          (productId && String(item.product_id) === productId) ||
          (variantId && String(item.id) === variantId)
        );
      });

      if (inCart) {
        $btn.val(ATC_IN_CART_LABEL);
        $btn.addClass('is-in-cart');
      } else {
        $btn.val($btn.data('original-label'));
        $btn.removeClass('is-in-cart');
      }
    });
  }

  /**
   * Get /cart.js and update all button types
   */
  function syncAllButtonsWithCart() {
    $.getJSON('/cart.js', function(cart) {
      syncMainProductButtons(cart);
      syncCollectionButtons(cart);
    });
  }

  // ---------------------------------------------------------------------------
  // Collection / grid "Add to Cart" buttons (.list__add-to-cart)
  // - Uses AJAX
  // - Updates mini-cart
  // - Now keeps label as "In Cart" and knows it after reload
  // ---------------------------------------------------------------------------
  $(document).on('click', '.list__add-to-cart', function() {
    var $button = $(this);
    var currentQty = $(
      '.mini-cart-item[data-variant="' +
        $button.attr('data-variant-id') +
        '"] .mini-cart-item-quantity span'
    ).html();
    var maxQuantityAllowed = $button.attr('data-max-qty');

    if (maxQuantityAllowed && currentQty >= maxQuantityAllowed) {
      $button
        .parent()
        .append(
          '<div>Only maximum ' +
            maxQuantityAllowed +
            ' quantity allowed per order</div>'
        );
      $button.remove();
      return;
    }

    $button.val('Adding…');

    var formData = new FormData();
    formData.append('quantity', 1);
    formData.append('id', $button.attr('data-variant-id'));
    formData.append('product-id', $button.attr('data-product-id'));
    formData.append('form_type', 'product');

    fetch(window.Theme.routes.cart_add_url + '.js', {
      method: 'POST',
      body: formData,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(function(response) {
        if (!response.ok) {
          var error = new Error();
          error.response = response;
          throw error;
        }
        return response.json();
      })
      .then(function(item) {
        if (!item) return;

        // This button becomes "In Cart" immediately
        $button.val(ATC_IN_CART_LABEL);
        $button.addClass('is-in-cart');

        // Refresh mini-cart section
        return fetch('/?sections=mini-cart')
          .then(function(response) {
            return response.json();
          })
          .then(function(el) {
            el = el['mini-cart'];

            var dataEls = $(el).find('[data-data]');
            var newData = {};

            if (
              dataEls.length === 1 &&
              dataEls[0].getAttribute('data-data') === ''
            ) {
              newData = JSON.parse(dataEls[0].innerHTML);
            } else {
              for (var _i = 0; _i < dataEls.length; _i++) {
                newData[dataEls[_i].getAttribute('data-data')] = JSON.parse(
                  dataEls[_i].innerHTML
                );
              }
            }

            var htmlEls = $(el).find('[data-html]');
            var newHtml = {};

            if (
              htmlEls.length === 1 &&
              htmlEls[0].getAttribute('data-html') === ''
            ) {
              newHtml = htmlEls[0].innerHTML;
            } else {
              for (var i = 0; i < htmlEls.length; i++) {
                newHtml[htmlEls[i].getAttribute('data-html')] =
                  htmlEls[i].innerHTML;
              }
            }

            var cartCount = document.querySelector('.cart-count-number');
            if (cartCount && newData.itemCount != null) {
              cartCount.innerText = newData.itemCount;
            }

            $('.mini-cart-wrapper .mini-cart').remove();
            $('.mini-cart-wrapper').append(newHtml['miniCart']);

            // After mini-cart update, keep everything in sync with latest cart
            syncAllButtonsWithCart();
          });
      })
      .catch(function(error) {
        console.log(error);
      });
  });

  // ---------------------------------------------------------------------------
  // Main Product Page "Add to Cart" button (.js-atc-button)
  // - Reads cart via /cart.js
  // - If this product is in cart => label = "In Cart" + .is-in-cart
  // - Resyncs after click (once theme's own add-to-cart finishes)
  // ---------------------------------------------------------------------------

  // Initial sync on page load (covers PDP + grids)
  syncAllButtonsWithCart();

  // After clicking the main product Add to Cart, re-check cart after a short delay
  $(document).on('click', '.js-atc-button', function() {
    // Let the theme's own add-to-cart submit complete (if AJAX)
    setTimeout(syncAllButtonsWithCart, 800);
  });
});